export default "__VITE_ASSET__D6X9reCm__"